import { createRoot } from "react-dom/client";
import "./reset.css";
import "./styles.css";
import App from "./App";

createRoot(document.getElementById("root")).render(<App />);
